import { useState } from 'react'
import { X, ExternalLink } from 'lucide-react'

interface PolicyAgreementProps {
  onAgree: () => void
  onDecline: () => void
  title: string
  subtitle?: string
}

export default function PolicyAgreement({ 
  onAgree, 
  onDecline, 
  title, 
  subtitle 
}: PolicyAgreementProps) {
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const [agreedToPrivacy, setAgreedToPrivacy] = useState(false)

  const openTerms = () => {
    window.open('/TERMS_OF_USE.txt', '_blank')
  }

  const openPrivacy = () => {
    window.open('/PRIVACY_POLICY.txt', '_blank')
  }

  const canProceed = agreedToTerms && agreedToPrivacy

  return (
    <div className="modal-overlay animate-fade-in">
      <div className="modal animate-slide-up max-w-lg">
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
              {subtitle && (
                <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
              )}
            </div>
            <button
              onClick={onDecline}
              className="text-gray-400 hover:text-gray-600 p-1"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <p className="text-gray-700 mb-6">
            在使用 Sku Studio 之前，请仔细阅读并同意以下条款：
          </p>

          <div className="space-y-4 mb-6">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <input
                  type="checkbox"
                  id="terms"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <label htmlFor="terms" className="text-sm text-gray-700 flex-1">
                我已阅读并同意{' '}
                <button
                  type="button"
                  onClick={openTerms}
                  className="text-blue-600 hover:text-blue-700 underline inline-flex items-center gap-1"
                >
                  《使用条款》
                  <ExternalLink className="w-3 h-3" />
                </button>
              </label>
            </div>

            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <input
                  type="checkbox"
                  id="privacy"
                  checked={agreedToPrivacy}
                  onChange={(e) => setAgreedToPrivacy(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
              </div>
              <label htmlFor="privacy" className="text-sm text-gray-700 flex-1">
                我已阅读并同意{' '}
                <button
                  type="button"
                  onClick={openPrivacy}
                  className="text-blue-600 hover:text-blue-700 underline inline-flex items-center gap-1"
                >
                  《隐私政策》
                  <ExternalLink className="w-3 h-3" />
                </button>
              </label>
            </div>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              请点击上方链接仔细阅读完整的条款和政策。您的同意表示您理解并接受这些条款的约束。
            </p>
          </div>
        </div>

        <div className="flex gap-3 p-6 pt-0">
          <button
            onClick={onDecline}
            className="flex-1 btn-secondary"
          >
            不同意
          </button>
          <button
            onClick={onAgree}
            disabled={!canProceed}
            className="flex-2 btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
          >
            同意并继续
          </button>
        </div>
      </div>
    </div>
  )
}